import { render, staticRenderFns } from "./EmbargosRemotosIpaam.vue?vue&type=template&id=4762f8bb&lang=pug"
import script from "./EmbargosRemotosIpaam.vue?vue&type=script&lang=js"
export * from "./EmbargosRemotosIpaam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports